import { isNil } from 'ramda';
import { commitMutation,
  graphql } from 'react-relay';
import environment from '../.';
import { notifyAuthLogout } from '../../utils/authLogout';
import { onErrorMutation } from './common/common';

const mutation = graphql`
mutation SignOutMutation {
  signOut { 
    ok
    error
    user {
      id
      email
    }
  }
}
`;

export default (done) => {
  const variables = {};

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      updater: () => {
      },
      optimisticUpdater: () => {
      },
      onCompleted: ({ signOut: { ok, error } }) => {
        // ok:false may mean the session was already gone, but also that the sign-out call itself failed.
        // We still clear local state and notify other tabs; callers redirect either way.
        if (!ok) console.warn('signOut returned ok:false, forcing local logout anyway', error);
        notifyAuthLogout();
        if (!isNil(done)) done(ok, error);
      },
      onError: (error) => {
        notifyAuthLogout();
        onErrorMutation(error, done);
      }
    }
  );
};
